import React from 'react';
import './PageStyles.css';

const Contact = () => {
    return (
        <div className="page-container">
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1 className="page-hero-title">Contact Us</h1>
                    <p className="page-hero-subtitle">
                        Get in touch with our team. We're here to help.
                    </p>
                </div>
            </section>
            <section className="value-props-section">
                <div className="value-props-container">
                    <div style={{ textAlign: 'center', padding: '2rem' }}>
                        <p style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>
                            For inquiries, please contact us at:
                        </p>
                        <a
                            href="mailto:admin@colorkarma.com"
                            style={{
                                fontSize: '1.5rem',
                                color: '#007bff',
                                textDecoration: 'none',
                                fontWeight: '500'
                            }}
                        >
                            admin@colorkarma.com
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;

